import React from 'react';
import { FaInstagram, FaTwitter, FaFacebook, FaEnvelope, FaTiktok } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="font-Poppins bg-gray-800 text-white py-8 dark:bg-slate-950 dark:text-gray-100">
      <div className="max-w-7xl mx-auto px-4">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 border-b border-gray-600 pb-6 dark:border-slate-700">
          {/* Contact Information */}
          <div>
            <h2 className="text-lg font-bold mb-2">Contact Us</h2>
            <p>15, Dayo Abatan Street, Ijeun titun</p>
            <p>Abeokuta, Ogun State</p>
            <p>+234-8131591112 - Qoncave</p>
            <p>helloqoncave@gmail.com</p>
            <p>Mon-Fri - 08:00-19:00</p>
          </div>

          {/* Navigation Links */}
          <div>
            <h2 className="text-lg font-bold mb-2">Navigation</h2>
            <ul className="space-y-1">
              <li><a href="/home" className="hover:underline text-gray-200 dark:text-gray-300">Home</a></li>
              <li><a href="/about" className="hover:underline text-gray-200 dark:text-gray-300">About</a></li>
              <li><a href="/portfolio" className="hover:underline text-gray-200 dark:text-gray-300">Portfolio</a></li>
              <li><a href="/services" className="hover:underline text-gray-200 dark:text-gray-300">Services</a></li>
              <li><a href="/testimonials" className="hover:underline text-gray-200 dark:text-gray-300">Testimonials</a></li>
              <li><a href="/contact" className="hover:underline text-gray-200 dark:text-gray-300">Contact</a></li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h2 className="text-lg font-bold mb-2">Follow Us</h2>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/qoncave"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-orange-500"
              >
                <FaInstagram size={24} />
              </a>
              <a
                href="https://www.twitter.com/qoncave"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-orange-500"
              >
                <FaTwitter size={24} />
              </a>
              <a
                href="https://web.facebook.com/people/Qoncave-Designs/61585557615198/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-orange-500"
              >
                <FaFacebook size={24} />
              </a>
              <a
                href="mailto:helloqoncave@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-orange-500"
              >
                <FaEnvelope size={24} />
              </a>
              <a
                href="https://vm.tiktok.com/ZSHE1WkVtGuNw-yqQFY/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-orange-500"
              >
                <FaTiktok size={24} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between mt-6 text-sm text-orange-400">
          <p>Qoncave © {new Date().getFullYear()} All rights reserved</p>
          
          <p>
            Powered By{" "}
            <a 
              href="https://www.qoncave.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:underline"
            >
              Qoncave
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
